import PropTypes from "prop-types";
import { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  ListItemText,
  ListItemButton,
  ListItemIcon,
  SvgIcon,
  Popover,
  useTheme,
} from "@mui/material";
import { ExpandableSidebarStateContext } from "@context/shared/ExpandableSidebarState";
import { AssetHoverCard } from "../asset-hover-card";
import { AssetBreadcrumbs } from "../asset-breadcrumbs";
import useAssetStore from "@stores/client/useAssetStore";
import { usePopover } from "@hooks/shared/use-popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";

export const FilterListItem = (props) => {
  const { item } = props;
  const popover = usePopover();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const { state } = useContext(ExpandableSidebarStateContext);
  const theme = useTheme();
  const { currentRootId } = useAssetStore();

  return (
    <ListItemButton
      alignItems="flex-start"
      selected={item.route != null && pathname.endsWith(item.route.toString())}
      sx={{
        "&.Mui-selected": {
          backgroundColor: theme.palette.background.paper,
          border: "solid 1px",
          borderColor: theme.palette.divider,
          borderRadius: "6px",
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
        backgroundColor: popover.open ? theme.palette.action.hover : "",
        pointerEvents: state.type === "dragging" ? "none" : "auto",
        marginRight: 1,
      }}
      ref={popover.anchorRef}
      onMouseEnter={popover.handleOpen}
      onMouseLeave={popover.handleClose}
      onClick={() => {
        if (item.route != null) navigate(`/assets/${currentRootId}/${item.route}`);
      }}
    >
      <ListItemIcon>
        <SvgIcon sx={{ fontSize: "0.4rem", mt: "0.3rem" }}>
          <FontAwesomeIcon icon={faCircle} />
        </SvgIcon>
      </ListItemIcon>
      <ListItemText
        slotProps={{
          style: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
            maxWidth: "calc(100% - 20px)",
            flexShrink: 1,
          },
        }}
        primary={item.title}
        secondary={
          <AssetBreadcrumbs
            breadcrumbData={item.breadcrumbs ? JSON.parse(item.breadcrumbs) : []}
            rootId={currentRootId}
            version="mini"
          />
        }
      />
      <Popover
        sx={{
          pointerEvents: "none",
          transform: "translateX(10px)",
        }}
        open={popover.open}
        anchorEl={popover.anchorRef.current}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onClose={popover.handleClose}
        disableRestoreFocus
        slotProps={{
          paper: {
            sx: {
              pointerEvents: "auto",
              backgroundColor: "transparent",
              boxShadow: "none",
            },
            onMouseEnter: popover.handleOpen,
            onMouseLeave: popover.handleClose,
          },
        }}
      >
        <AssetHoverCard item={item} hasBreadcrumb={true} />
      </Popover>
    </ListItemButton>
  );
};
FilterListItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    route: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    breadcrumbs: PropTypes.string,
  }).isRequired,
};
